import { camelCase } from 'lodash';

import IcnHero from '@swf/core/assets/casino/icnHero.jpg';
import IcnHeroSquare from '@swf/core/assets/casino/icnHeroSquare.png';
import IcnHeroWide from '@swf/core/assets/casino/icnHeroWide.png';
import IcnLive from '@swf/core/assets/casino/icnLive.jpg';
import IcnPoster from '@swf/core/assets/casino/icnPoster.jpg';
import IcnSquare from '@swf/core/assets/casino/icnSquare.jpg';
import IcnStandard from '@swf/core/assets/casino/icnStandard.jpg';
import IcnWide from '@swf/core/assets/casino/icnWide.jpg';
import type { CasinoGameImage } from '@swf/core/types/CasinoGame';
import { CasinoIcon } from '@swf/generated/types/common/Casino';

export const iconMeta = {
  [CasinoIcon.icnAnimated]: {
    ims: [CasinoIcon.icnAnimated, CasinoIcon.icnStandard],
    fallback: IcnHeroSquare,
    animated: true
  },
  [CasinoIcon.icnAnimatedSquare]: {
    ims: [CasinoIcon.icnAnimatedSquare, CasinoIcon.icnSquare],
    animated: true
  },
  [CasinoIcon.icnAnimatedHeroSquare]: {
    ims: [CasinoIcon.icnAnimatedHeroSquare, CasinoIcon.icnHeroSquare],
    animated: true
  },
  [CasinoIcon.icnAnimatedHeroWide]: {
    ims: [CasinoIcon.icnAnimatedHeroWide, CasinoIcon.icnHeroWide],
    animated: true
  },
  [CasinoIcon.icnAnimatedWide]: {
    ims: [CasinoIcon.icnAnimatedWide, CasinoIcon.icnWide],
    animated: true
  },
  [CasinoIcon.icnHero]: { ims: [CasinoIcon.icnHero], fallback: IcnHero },
  [CasinoIcon.icnHeroSquare]: {
    ims: [CasinoIcon.icnHeroSquare],
    mobile: 235,
    desktop: 373,
    fallback: IcnHeroSquare
  },
  [CasinoIcon.icnHeroWide]: {
    ims: [CasinoIcon.icnHeroWide],
    mobile: 404,
    desktop: 1155,
    fallback: IcnHeroWide
  },
  [CasinoIcon.icnLive]: {
    ims: [CasinoIcon.icnLive],
    fallback: IcnLive
  },
  [CasinoIcon.icnStandard]: { ims: [CasinoIcon.icnStandard], fallback: IcnStandard },
  [CasinoIcon.icnOnTable]: { ims: [CasinoIcon.icnOnTable] },
  [CasinoIcon.icnPoster]: {
    ims: [CasinoIcon.icnPoster],
    mobile: 127,
    desktop: 178,
    fallback: IcnPoster
  },
  [CasinoIcon.icnSquare]: {
    ims: [CasinoIcon.icnSquare],
    mobile: 127,
    desktop: 178,
    fallback: IcnSquare
  },
  [CasinoIcon.icnWide]: { ims: [CasinoIcon.icnWide], mobile: 265, desktop: 756, fallback: IcnWide },
  [CasinoIcon.icnRace]: { ims: [CasinoIcon.icnRace, CasinoIcon.icnSquare] }
};

export const needsVideoTag = (path: string) => path.match(new RegExp('mp4', 'i'));

export const getIconWidth = (icon: CasinoIcon, isMobile: boolean): number =>
  iconMeta[icon].ims.reduce(
    (result: number, item: CasinoIcon) => result || iconMeta[item][isMobile ? 'mobile' : 'desktop'],
    null
  );

export const getIconFallback = (icon: CasinoIcon) =>
  iconMeta[icon].ims.reduce(
    (result: HTMLImageElement, item: CasinoIcon) => result || iconMeta[item].fallback,
    null
  );

export const getIconClassKeys = (icon: CasinoIcon) =>
  iconMeta[icon].ims.reduce((result: string[], item: CasinoIcon) => {
    result.push(camelCase(item));
    return result;
  }, []);

export const getRenderIcon = (
  icon: CasinoIcon,
  isMobile: boolean,
  images: CasinoGameImage
): string =>
  iconMeta[icon].ims.reduce((result: string, item: CasinoIcon) => {
    const check = iconMeta[item];
    return check.animated && isMobile ? null : result || images[item];
  }, null);
